import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";
import AmountTd, {AmountTdWidth} from "../../../Table/Common/AmountTd";
import React from "react";
import LinkAccess from "../../../Access/LinkAccess";

function getColumns(props) {
    const { companyCurrencySymbol } = props;

    return [
        {
            title: t`Product`,
            dataIndex: 'product_name',
            key: 'product_name',
            width: 0,
            flexGrow: 16,
            cellRenderer: ({ rowData: record }) => {
                switch (record.rowType) {
                    case 'total':
                        return t`TOTAL`;
                    default:
                        if (!record.name)
                            return '-';
                        if (!record.id)
                            return record.name;
                        return (
                            <LinkAccess to={`/products/${record.id}`}>
                                { record.name }
                            </LinkAccess>
                        );
                }
            },
        },
        {
            title: t`Taxable Amount`,
            dataIndex: 'taxable_amount',
            key: 'taxable_amount',
            align: 'right',
            width: AmountTdWidth,
            cellRenderer: ({ rowData: record }) => (
                <AmountTd
                    currency_code={companyCurrencySymbol}
                    amount={record.taxable_amount}
                    style={{width: '100%'}}
                />
            ),
        },
        {
            title: t`Tax Amount`,
            dataIndex: 'tax_amount',
            key: 'tax_amount',
            align: 'right',
            width: AmountTdWidth,
            cellRenderer: ({ rowData: record }) => (
                <AmountTd
                    currency_code={companyCurrencySymbol}
                    amount={record.tax_amount}
                    style={{width: '100%'}}
                />
            ),
        },
    ];
}

export default {
    storageKey: StorageKey.report_sst_by_products,
    getReportLabel: () => t`SST by Products`,
    required: [
        'product_name',
        'taxable_amount',
        'tax_amount',
    ],
    defaulto: [],
    getColumns,
};
